export default (arr: string[]) => {
  const specialValues = ["No Data","Outside"];
  const normalItems = arr.filter((item) => !specialValues.includes(item));
  const specialItems = specialValues.filter((sv) => arr.includes(sv));
  return [...normalItems, ...specialItems];
};
